import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });

const describeFilters = (filters, searchQuery) => {
  const parts = [];
  if (filters.dateFrom && filters.dateTo) {
    parts.push(filters.dateFrom === filters.dateTo ? fmt(filters.dateFrom) : `${fmt(filters.dateFrom)} – ${fmt(filters.dateTo)}`);
  } else if (filters.dateFrom) parts.push(`From ${fmt(filters.dateFrom)}`);
  else if (filters.dateTo) parts.push(`Until ${fmt(filters.dateTo)}`);
  if (filters.category) parts.push(filters.category);
  if (filters.priority) parts.push(`${filters.priority} priority`);
  if (filters.completed === 'true') parts.push('Completed only');
  if (filters.completed === 'false') parts.push('Active only');
  if (searchQuery) parts.push(`“${searchQuery}”`);
  return parts.length ? parts.join(' · ') : 'All tasks';
};

// Desktop-only: renders the currently filtered task list as an A4 PDF and opens it for printing.
export const PrintTasksButton = ({ tasks, filters, searchQuery, workspaceName }) => {
  const [busy, setBusy] = useState(false);

  const handlePrint = async () => {
    const win = window.open('', '_blank');
    setBusy(true);
    try {
      const { data } = await axios.post(
        `${API}/tasks/print-pdf`,
        {
          task_ids: tasks.map((t) => t.id),
          title: 'Task list',
          filters_summary: describeFilters(filters, searchQuery),
          workspace_name: workspaceName,
          tz_offset_minutes: new Date().getTimezoneOffset(),
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, responseType: 'blob' }
      );
      const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
      if (win) win.location.href = url;
      else window.location.assign(url);
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (err) {
      if (win) win.close();
      toast.error('Could not create the PDF. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={handlePrint}
      disabled={busy || tasks.length === 0}
      data-testid="tasks-print-pdf-button"
      title="Print the tasks currently shown as a PDF"
      className="text-slate-700 hover:text-slate-900 font-medium text-sm inline-flex items-center gap-1.5 px-4 py-2 bg-white rounded-lg shadow-sm border border-slate-200 hover:bg-slate-50 disabled:opacity-50 transition-colors"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
      </svg>
      {busy ? 'Preparing PDF…' : `Print list (${tasks.length})`}
    </button>
  );
};
